/**
 * AppData.ts
 */
export class AppData {
}
//# sourceMappingURL=AppData.js.map